import axios from 'axios';
import { fetchAuthSession } from 'aws-amplify/auth';
import { getApiEndpoint } from '../config/api.js';

export interface AuthRequest {
  password: string;
}

export interface AuthResponse {
  success: boolean;
  message?: string;
}

const AUTH_STORAGE_KEY = 'akem_auth_token';
const AUTH_MARKER = 'authenticated';

/**
 * Authenticate with the API server
 */
export const authenticateWithServer = async (
  password: string
): Promise<AuthResponse> => {
  try {
    const response = await axios.post<AuthResponse>(
      `${getApiEndpoint()}/auth`,
      { password },
      {
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );

    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      if (error.response?.data?.message) {
        return {
          success: false,
          message: error.response.data.message,
        };
      }

      return {
        success: false,
        message: error.message || 'Authentication failed',
      };
    }

    return {
      success: false,
      message: 'An unexpected error occurred',
    };
  }
};

export const markAuthenticated = (): void => {
  localStorage.setItem(AUTH_STORAGE_KEY, AUTH_MARKER);
};

export const clearAuthentication = (): void => {
  localStorage.removeItem(AUTH_STORAGE_KEY);
};

export const hasAuthentication = (): boolean => {
  return localStorage.getItem(AUTH_STORAGE_KEY) === AUTH_MARKER;
};

export const getAuthHeaders = async (): Promise<Record<string, string>> => {
  try {
    const session = await fetchAuthSession();
    const token = session.tokens?.idToken?.toString();
    return token ? { Authorization: `Bearer ${token}` } : {};
  } catch {
    return {};
  }
};
